import { Link } from '@tanstack/react-router';
import { ArrowRightIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';

interface NavButtonToolResultProps {
  /** Destination path (may include a query string). */
  to: string;
  label: string;
}

/**
 * Inline "Go/Open →" button rendered from a navigation tool result. Uses a
 * real `<Link>` (typed `string` — TanStack collapses `to` to string for
 * non-literals) so keyboard/middle-click/open-in-new-tab work. Navigating
 * away keeps the Nami conversation (agent state lives at the layout level).
 */
export function NavButtonToolResult({ to, label }: NavButtonToolResultProps) {
  return (
    <Button asChild variant="secondary" size="sm" className="gap-1.5">
      <Link to={to}>
        {label}
        <ArrowRightIcon className="h-3.5 w-3.5" weight="bold" />
      </Link>
    </Button>
  );
}
